import { render } from "./itemslider.vue?vue&type=template&id=0cdfbd60&scoped=true"
import script from "./itemslider.vue?vue&type=script&lang=js"
export * from "./itemslider.vue?vue&type=script&lang=js"

import "./itemslider.vue?vue&type=style&index=0&id=0cdfbd60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdfbd60"],['__file',"src/js/components/itemslider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cdfbd60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cdfbd60', __exports__)) {
    api.reload('0cdfbd60', __exports__)
  }
  
  module.hot.accept("./itemslider.vue?vue&type=template&id=0cdfbd60&scoped=true", () => {
    api.rerender('0cdfbd60', render)
  })

}


export default __exports__